import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { ButterflyDecor } from './ui/ButterflyDecor';
export function FinalCTA() {
  return <section className="relative py-24 overflow-hidden" data-id="element-47">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-light to-brand-teal/10 -z-10" data-id="element-48" />

      {/* Decorative butterflies */}
      <ButterflyDecor className="absolute top-8 left-10 w-[180px] h-[160px] opacity-[0.09] pointer-events-none select-none rotate-[15deg]" data-id="element-49" />
      <ButterflyDecor className="absolute bottom-4 right-8 w-[240px] h-[216px] opacity-[0.07] pointer-events-none select-none rotate-[-10deg]" data-id="element-50" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-51">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-52">
          Start Verifying Your Patient Coverage Now
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg md:text-xl text-slate-700 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-53">
          Join healthcare practices that are streamlining their front-office
          workflows with enSwift.
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col items-center" data-id="element-54">
          <button className="bg-brand-teal hover:bg-brand-dark text-white px-10 py-4 rounded-xl font-bold text-lg transition-colors shadow-lg shadow-brand-teal/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-brand-teal mb-6" data-id="element-55">
            Start Verifying Now
          </button>
          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-slate-600 font-medium" data-id="element-56">
            <div className="flex items-center gap-1.5" data-id="element-57">
              <ShieldCheckIcon className="w-4 h-4 text-brand-teal" data-id="element-58" />
              HIPAA Compliant
            </div>
            <span data-id="element-59">•</span>
            <span data-id="element-60">Cancel Anytime</span>
          </div>
        </motion.div>
      </div>
    </section>;
}